import React, { createContext, PropsWithChildren, useContext, useEffect } from 'react';

import { useLiveQuery } from 'dexie-react-hooks';

import {
  discoPrototypeStore,
  Plate,
} from 'client/app/apps/disco-prototype/dataStore/dexieStore';

type PlateContextType = {
  plates: Plate[];
};

export const PlateContext = createContext<PlateContextType | undefined>(undefined);

const data = {
  data: {
    discoPlateDefinitions: [
      {
        id: '1',
        description: '96 Well, 200ul',
        rows: 8,
        columns: 12,
        maxVolume: 10e-6,
      },
      {
        id: '2',
        description: '384 Well, 100ul',
        rows: 16,
        columns: 24,
        maxVolume: 10e-6,
      },
      {
        id: '3',
        description: '1536 Well, 13ul',
        rows: 32,
        columns: 48,
        maxVolume: 10e-6,
      },
    ],
  },
};

export const usePlateContext = () => {
  const context = useContext(PlateContext);
  if (context === undefined) {
    throw new Error('usePlateContext must be used within a PlateProvider');
  }
  return context;
};

export function PlateProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    (async () => {
      await discoPrototypeStore.clearPlates();
      await discoPrototypeStore.addPlates(data.data.discoPlateDefinitions);
    })();
  }, []);

  const plates = useLiveQuery(() => discoPrototypeStore.getPlates(), []);

  const value = { plates: plates || [] };

  return <PlateContext.Provider value={value}>{children}</PlateContext.Provider>;
}
